import React from 'react';

export default
<g id="icon/upload/white" stroke="none" strokeWidth="1">
    <path d="M14.2749372,24.3532526 L22.1870958,24.3532526 L22.1870958,15.8826021 L27.4615385,15.8826021 L18.2310165,6 L9,15.8826021 L14.2749372,15.8826021 L14.2749372,24.3532526 Z M9,27.1766263 L27.4615385,27.1766263 L27.4615385,30 L9,30 L9,27.1766263 Z"></path>
</g>
